import { Box, Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import "./css/AddnewModels.css"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { MdKeyboardArrowDown } from 'react-icons/md'
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PersonIcon from '@mui/icons-material/Person';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from 'draft-convert';
import axios from "axios";
import api from "../config/backend";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import DOMPurify from 'dompurify';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },

}));

const availableColors = [
    "rgb(0, 200, 200)",
    "rgb(250, 216, 207)",
    "rgb(251, 226, 196)",
    "rgb(206, 202, 240)",
    "rgb(200, 200, 200)",
];

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const AddNewModels = ({ isDailog, setDailog, leadData, setTriggerRefresh }) => {

    const [open, setOpen] = useState(false);
    const [modelopen, setModelOpen] = useState(false);
    const [selectedColor, setSelectedColor] = useState(availableColors[0]);
    const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);
    const [convertedContent, setConvertedContent] = useState([]);
    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    );

    console.log(editorState)


    useEffect(() => {
        let html = convertToHTML(editorState.getCurrentContent());
        setConvertedContent(html);
    }, [editorState]);

    console.log(convertedContent);


    function createMarkup(html) {
        console.log(html)
        return {
            __html: DOMPurify.sanitize(html)
        }
    }

    const [shouldShowEditor, setShouldShowEditor] = useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleModelClickOpen = () => {
        setModelOpen(true);
    };
    const handleModelClose = () => {
        setModelOpen(false);
    };

    // tabs
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleColorSelection = (color) => {
        setSelectedColor(color);
    };
    const handleToggleColorPicker = () => {
        setIsColorPickerVisible(prevState => !prevState);
    };

    // 
    const [submittedContent, setSubmittedContent] = useState('');
    const [submittedValues, setSubmittedValues] = useState([]);

    const [domic, setDomic] = useState('');

    const handleChangedomain = (event) => {
        setDomic(event.target.value);
    };
    const token = localStorage.getItem("_crm__token")

    const handleSubmit = async () => {
        const newSubmittedContent = editorState.getCurrentContent().getPlainText();
        setSubmittedValues((prevValues) => [...prevValues, newSubmittedContent]);
        setSubmittedContent(newSubmittedContent);

        // if (convertedContent === "<p></p>") {
        //     return
        // }
       
        try {
            if (!newSubmittedContent.trim().length) {
                toast.error('Please write a note before submitting.', { autoClose: 3000 });
                return;
            }

            const response = await axios.post(`${api}/Leads/add-note`, {
                token,
                hash: leadData.hash,
                note: convertedContent,
            });

            if (response.data.success) {
                toast.success('Note added successfully.', { autoClose: 3000 });
                console.log("Note added successfully.");
                setTriggerRefresh(prev => prev + 1)
                setDailog(false)
                setEditorState(EditorState.createEmpty());
            } else {
                toast.error(`Failed to add note: ${response.data.message}`, { autoClose: 3000 });
                console.log("Failed to add note:", response.data.message);
            }
        } catch (error) {
            toast.error('An error occurred while adding the note. Please try again later.', { autoClose: 3000 });
            console.error("An error occurred while adding the note:", error);
        }
    }


    


    return (
        <div className='_7cbg'>
            <div className="">
                <BootstrapDialog
                    className='app-dialog-addlead'
                    onClose={() => setDailog()}
                    aria-labelledby="customized-dialog-title"
                    open={isDailog}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Add Note
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setDailog()}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <div className="app-component-addnote">
                            <Editor
                                className="app-component-addnote__editor"
                                editorState={editorState}
                                onEditorStateChange={setEditorState}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                            // toolbar={{
                            //     options: ['inline', 'blockType']
                            // }}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button className='app-btn-text'     onClick={() => setDailog()} autoFocus >
                            Cancel
                        </Button>
                        <Button variant='contained' className='app-btn-contained app-btn-primary' autoFocus onClick={handleSubmit}>Submit</Button>
                    </DialogActions>
                </BootstrapDialog>
            </div>
            <div>
                {/* <Button variant="outlined" onClick={handleModelClickOpen}>
                    <span style={{ textTransform: "none", marginLeft: "10px" }}>New Activity</span>
                </Button> */}
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={modelopen}
                >
                    <DialogTitle
                        sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Modal title
                    </DialogTitle>
                    
                    <IconButton
                        aria-label="close"
                        onClick={handleModelClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs className="_3wgp" value={value} onChange={handleChange} centered aria-label="basic tabs example">
                                    <Tab className="_6onv" label="New Task" {...a11yProps(0)} />
                                    <Tab label="Call/meeting" {...a11yProps(1)} />
                                    <Tab label="other" {...a11yProps(2)} />
                                </Tabs>
                            </Box>
                            <CustomTabPanel value={value} index={0}>
                                <Box className="_5lqt">
                                    <TextField
                                        sx={{ marginTop: 2, width: '50ch' }}
                                        label="Write a Note"
                                    />
                                    <div className="color-pickerr">
                                        <div className="color-picker-toggleee" onClick={handleToggleColorPicker}>
                                            <MdKeyboardArrowDown />
                                        </div>
                                        {isColorPickerVisible && (
                                            <div className="color-optionsss">
                                                <div className='color-options-first'>
                                                    {availableColors.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            className="color-option"
                                                            style={{ backgroundColor: color }}
                                                            onClick={() => handleColorSelection(color)}
                                                        >
                                                        </div>
                                                    ))}
                                                </div>
                                                <button onClick={handleToggleColorPicker}>ok</button>
                                            </div>
                                        )}
                                    </div>
                                </Box>
                                <Box>
                                    <div className="_9hrc">
                                        <div className="_2nym" onClick={() => setShouldShowEditor(true)}>
                                            <span> <FormatAlignLeftIcon className='Icons' />Add Description </span>
                                        </div>
                                        <div className="_0tou">
                                            <TextField
                                                fullWidth
                                                sx={{ marginTop: 2 }}
                                                label="Write a Note" />
                                        </div>
                                    </div>
                                    <div className="_4nsb" >
                                        <AccessTimeIcon className='Icons' />
                                        <Typography variant='span'>Aug 09 1985</Typography>
                                    </div>
                                    <div className="_9ybi">
                                        <InsertLinkIcon className='Icons' />
                                        <TextField
                                            sx={{ marginTop: "10px" }}
                                            fullWidth
                                            label="Write a Note"
                                        />
                                    </div>
                                    <div className="_9ybi">
                                        <PersonIcon className='Icons' />
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Team Member Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={domic}
                                                label="Domic"
                                                onChange={handleChangedomain}
                                            >
                                                <MenuItem value={10}>rajesh</MenuItem>
                                                <MenuItem value={20}>Pranathi</MenuItem>
                                                <MenuItem value={30}>Raj TL</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Box className="_5lqt">
                                    <TextField
                                        sx={{ marginTop: 2, width: '50ch' }}
                                        label="Write a Note"
                                    />
                                    <div className="color-pickerr">
                                        <div className="color-picker-toggleee" onClick={handleToggleColorPicker}>
                                            <MdKeyboardArrowDown />
                                        </div>
                                        {isColorPickerVisible && (
                                            <div className="color-optionsss">
                                                <div className='color-options-first'>
                                                    {availableColors.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            className="color-option"
                                                            style={{ backgroundColor: color }}
                                                            onClick={() => handleColorSelection(color)}
                                                        >
                                                        </div>
                                                    ))}
                                                </div>
                                                <button onClick={handleToggleColorPicker}>ok</button>
                                            </div>
                                        )}
                                    </div>
                                </Box>
                                <Box>
                                    <div className="_9hrc">
                                        <div className="_2nym" onClick={() => setShouldShowEditor(true)}>
                                            <span> <FormatAlignLeftIcon className='Icons' />Add Description </span>
                                        </div>
                                        <div className="_0tou">
                                            <TextField
                                                fullWidth
                                                sx={{ marginTop: 2 }}
                                                label="Write a Note" />
                                        </div>
                                    </div>
                                    <div className="_4nsb" >
                                        <AccessTimeIcon className='Icons' />
                                        <TextField
                                            sx={{ border: 'none', "& fieldset": { border: 'none' }, }}
                                            id="date"
                                            type="date"
                                            defaultValue="2017-05-24"
                                        />
                                    </div>
                                    <div className="_9ybi">
                                        <InsertLinkIcon className='Icons' />
                                        <TextField
                                            sx={{ marginTop: "10px" }}
                                            fullWidth
                                            label="Write a Note"
                                        />
                                    </div>
                                    <div className="_9ybi">
                                        <PersonIcon className='Icons' />
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Team Member Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={domic}
                                                label="Domic"
                                                onChange={handleChangedomain}
                                            >
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={2}>
                                <Box className="_5lqt">
                                    <TextField
                                        sx={{ marginTop: 2, width: '50ch' }}
                                        label="Write a Note"
                                    />
                                    <div className="color-pickerr">
                                        <div className="color-picker-toggleee" onClick={handleToggleColorPicker}>
                                            <MdKeyboardArrowDown />
                                        </div>
                                        {isColorPickerVisible && (
                                            <div className="color-optionsss">
                                                <div className='color-options-first'>
                                                    {availableColors.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            className="color-option"
                                                            style={{ backgroundColor: color }}
                                                            onClick={() => handleColorSelection(color)}
                                                        >
                                                        </div>
                                                    ))}
                                                </div>
                                                <button onClick={handleToggleColorPicker}>ok</button>
                                            </div>
                                        )}
                                    </div>
                                </Box>
                                <Box>
                                    <div className="_9hrc">
                                        <div className="_2nym" onClick={() => setShouldShowEditor(true)}>
                                            <span> <FormatAlignLeftIcon className='Icons' />Add Description </span>
                                        </div>
                                        <div className="_0tou">
                                            <TextField
                                                fullWidth
                                                sx={{ marginTop: 2 }}
                                                label="Write a Note" />
                                        </div>
                                    </div>
                                    <div className="_4nsb" >
                                        <AccessTimeIcon className='Icons' />
                                        <Typography variant='span'>Aug 09 1985</Typography>
                                    </div>
                                    <div className="_9ybi">
                                        <InsertLinkIcon className='Icons' />
                                        <TextField
                                            sx={{ marginTop: "10px" }}
                                            fullWidth
                                            label="Write a Note"
                                        />
                                    </div>
                                    <div className="_9ybi">
                                        <PersonIcon className='Icons' />
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Team Member Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={domic}
                                                label="Domic"
                                                onChange={handleChangedomain}
                                            >
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Box>
                            </CustomTabPanel>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleModelClose}>
                            Save changes
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
            </div>
            {/* <div>
                <Button variant="outlined" onClick={handleClickOpen}>
                    Open dialog
                </Button>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Modal title
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <Typography gutterBottom>
                            Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
                            dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
                            consectetur ac, vestibulum at eros.
                        </Typography>
                        <Typography gutterBottom>
                            Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
                            Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                        </Typography>
                        <Typography gutterBottom>
                            Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus
                            magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec
                            ullamcorper nulla non metus auctor fringilla.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleClose}>
                            Save changes
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
            </div> */}
            
        </div>
    )
}

export default AddNewModels